<template>
  <div class="record-search" v-loading="loading" element-loading-text="拼命加载中">
    <div class="headLine">
      <img src="../leftAngle.png" alt="返回首页" @click="backIndex"/>
      人员出入库管理
    </div>
    <div class="search-input">
      <div class="search-select">
        <el-date-picker
          v-model="startDate"
          type="date"
          style="width: 48%"
          placeholder="开始日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptionsStart"
        />
        <el-date-picker
          v-model="endDate"
          type="date"
          style="width: 48%"
          placeholder="结束日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptionsEnd"
        />
      </div>
      <div class="search-btn">
        <button class="btn btn-left" @click="clear">清除内容</button>
        <button class="btn btn-right" @click.prevent="searchRecord(1)">查询记录</button>
        <button class="bth holdList" @click.prevent="createRecord">新增人员入库信息</button>
      </div>
    </div>
    <div class="search-result warpper" ref="wrapper">
      <ul class="result-content content">
        <li class="result-item" v-for="(item, index) in recordList" :key="index">
          <div class="item-name">入库时间:{{item.date}} {{item.inTime}}</div>
          <div class="item-name">出库时间:{{item.date}} {{item.outTime}}</div>
          <div class="item-name">警官:{{item.police}}</div>
          <div class="item-number">原因：{{item.reason}}</div>
          <div class="item-btn">
            <el-button class="btn btn-right" @click="alterRecord(item.id)">查看</el-button>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import BScroll from 'better-scroll'
export default {
  data() {
    return {
      popstateLock: 0,//是否监听物理返回键
      loading: false,
      page: 1, // 分页查询，第一次为1
      pullupMsg: '加载更多',
      isShowTips: false,
      startDate: null,
      endDate: null,
      recordList:[],
      keyword: null,
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.endReportDate) {
            return  time.getTime() > new Date(this.endReportDate).getTime()-8.64e7
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.startReportDate) {
            return  time.getTime() < new Date(this.startReportDate).getTime()-8.64e7
          }
        }
      }
    };
  },
  created() {
    this.searchRecord(0);
  },
  watch: {
    popstateLock(val) {
      //在父组件调用方法改变lock的值的时候控制路由的监听来避免preview的close路由调用
      if (val) {
        this.addPopstate()
      } else {
        this.removePopstate()
      }
    }
  },
  destroyed() {
    this.removePopstate()
  },
  mounted() {
    this.addPopstate()//在导航栏挂载的时候，对物理返回键进行监听
    this.$nextTick(() => {
      this._initBScroll()
    })
  },
  methods: {
    addPopstate() {
      //判断是否H5路由
      if (window.history && window.history.pushState) {
        // 往历史记录里面添加一条新的当前页面的url
        history.pushState(null, null, document.URL);
        // 给 popstate 绑定一个方法 监听页面刷新，并绑定getBack()来控制
        window.addEventListener('popstate', this.getBack, false);//false阻止默认事件
      }
    },
    removePopstate() {
      //解除监听
      window.removeEventListener('popstate', this.getBack, false);//false阻止默认事件
    },
    //指挥路由
    getBack() {
      //判断物理返回键是否监听
      if (!this.popstateLock) {
        window.history.pushState(null, null, '#')
      }
    },
    // 返回首页
    backIndex() {
      this.$router.replace({name: 'hyWarehousePage'})
    },
    //新增出入库记录
    createRecord() {
      this.$router.replace({name: 'inAndOutRecord', query: {isCreate: true}})
    },
    //修改记录
    alterRecord(id) {
      this.$router.replace({name: 'inAndOutRecord', query: {id: id, isCreate: false}})
    },
    clear() {
      if (this.startDate || this.endDate) {
        this.startDate = null;
        this.endDate = null;
        this.searchRecord(0);
      }
    },
    searchRecord(valPost) {
      this.page = 1;
      let getStartDate = this.$route.query.startDate;
      let getEndDate = this.$route.query.endDate;
      let theStartDate = null;
      let theEndDate = null;
      if (valPost === 0) {
        if (getStartDate) {
          theStartDate = getStartDate;
          this.startDate = getStartDate;
        } else {
          theStartDate = null;
          this.startDate = null;
        }
        if (getEndDate) {
          theEndDate = getEndDate;
          this.endDate = getEndDate;
        } else {
          theEndDate = null;
          this.endDate = null;
        }
      } else {
        theStartDate = this.startDate;
        theEndDate = this.endDate;
      }
      this.$http.httpGet('/app/wWarehouseMemberRecord/list', {
        startDate: theStartDate,
        page: 1,
        limit: 10,
        endDate: theEndDate,
      }).then(res => {
        if (res.code === 0 && res.msg === 'success') {
          if (res.page.list.length == 0) {
            this.$message.info('查无记录')
          }
          this.recordList = res.page.list
          this.page++
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    _initBScroll() {
      if (!this.scroll) {
        this.scroll = new BScroll(this.$refs.wrapper, {
          //开启点击事件 默认为false
          click: true,
          scrollY: true,
          probeType: 3
        })
        // 一些监听
        this.scroll.on('scroll', (pos) => {
          if (pos.y - this.scroll.maxScrollY < -50) {
            this.isShowTips = true
          } else {
            this.isShowTips = false
          }
        })

        this.scroll.on('touchEnd', pos => {
          // 1.2.1监听下拉
          if (pos.y >= 50) {
            console.log('下拉刷新')
          }
          // 1.2.2监听上拉
          if (this.scroll.maxScrollY > pos.y + 50) {
            this.loading = true

            this.$http.httpGet('/app/wWarehouseMemberRecord/list', {
              startDate: this.startDate,
              page: this.page,
              limit: 10,
              endDate: this.endDate,
            }).then(res => {
              this.loading = false
              if (res.code === 0 && res.msg === 'success') {
                if (res.page.list.length == 0) {
                  this.$message.info('没有更多数据了')
                  return
                }
                this.page++
                let arr = res.page.list
                this.recordList = this.recordList.concat(arr)
                this.$nextTick(() => {
                  this.scroll.refresh()
                  this.scroll.finishPullUp()
                })
              } else {
                this.$message.error(res.msg)
              }
            })
          }
        })
      } else if (!this.$refs.wrapper) {
        return
      } else {
        this.scroll.refresh()
      }
    },
  },

}
</script>

<style scoped lang="scss">
//@import '@/assets/style/global.scss';
.record-search {
  margin: 0;
  padding: 50px 0 0;
  position: relative;
  width: 100%;
  .headLine {
    height: 50px;
    position: fixed;
    overflow: hidden;
    top: 0;
    left: 0;
    width: 100%;
    background-color: #fff;
    color: #000;
    font-weight: 600;
    text-align: center;
    line-height: 50px;
    z-index: 9;
    font-size: 16px;
    border-bottom: 1px #efefef solid;

    img {
      height: 30px;
      margin: 10px 0;
      padding: 0 10px;
      position: absolute;
      left: 0;
      top: 0;
    }

    button {
      display: inline-block;
      position: absolute;
      right: 0;
      top: 0;
      margin: 10px 0;
      padding: 0 10px;
      border: 0px;
      height: 30px;
      font-size: 30px;
      line-height: 30px;
      background-color: #fff;
    }
  }

  .search-input {
    position: relative;
    margin: 10px 0 20px;
    overflow: hidden;
    .search-select {
      display: flex;
      justify-content: space-between;
      text-align: center;
      padding: 0 20px 10px;

      .el-select {
        width: 100%;
      }
    }
    .search-btn {
      margin-top: 0;
      padding: 0 20px;
      button {
        height: 3.2rem;
        font-weight: 700;
        display: inline-block;
        width: 40%;
      }
      .btn-left {
        float: left;
        width: 48%;
        background-color: rgb(207, 0, 0);
      }
      .btn-right {
        float: right;
        width: 48%;
        background-color: rgb(6, 175, 6);
      }
      .holdList {
        width: 100%;
        background-color: #0066cb;
        border: none;
        margin-top: 15px;
        color: #fff;
        border-radius: 6px;
        height: 3.6rem;
      }
    }
  }

  .search-result {
    position: relative;
    padding: 0;
    height: calc(100vh - 50px - 120px - 60px);
    width: 100%;
    // height: 100%;
    overflow: hidden;
    .result-content {
      padding: 0 20px 10px;

      .result-item {
        position: relative;
        box-sizing: border-box;
        padding: 10px;
        border-radius: 0.5rem;
        margin-top: 1.6rem;
        /*height: 12rem;*/
        background-color: #f2f6fc;
        color: #303133;
        font-size: 1.6rem;
        box-shadow: 0 0.3rem 0.5rem #eee;

        .item-name,
        .item-number{
          position: relative;
          margin-bottom: 5px;
          height: 2rem;
          text-align: left;
          line-height: 2rem;
          font-size: 1.4rem;
          color: #000;
        }
        .item-time {
          position: absolute;
          left: 10px;
          top: 10px;
          height: 2rem;
          line-height: 2rem;
          font-size: 1.4rem;
          color: #000;
        }

        .item-reason {
          padding-top: 2.5rem;
          padding-bottom: 0.5rem;
          line-height: 3rem;
          font-size: 2rem;
        }

        .item-bottom {
          position: relative;
          left: 0px;
          bottom: 0px;
          width: 100%;
          height: 2rem;
          line-height: 2rem;
          font-size: 1.4rem;
        }

        .item-btn {
          position: relative;
          height: 3rem;
          line-height: 3rem;
          margin: 8px 0 10px;
          font-size: 1.4rem;
          color: #000;

          button {
            font-weight: 700;
            display: inline-block;
            width: 100%;
            background-color: #3A9DF2;
          }
          .btn-left {
            float: left;
          }
          .btn-right {
            float: right;
          }
        }
      }
    }
  }

    .record-create {
      position: fixed;
      left: 0px;
      bottom: 0px;
      text-align: center;
      width: 100%;
      background-color: #fff;
      z-index: 99;
      border-top: 1px #efefef solid;

      button {
        width: 80%;
        height: 4rem;
        margin: 10px 0;
        background-color: #67c23a;
        font-size: 1.6rem;
        font-weight: bold;

        &:hover,
        &:active {
          color: #fff;
        }
      }
    }
    .loading {
      position: fixed;
      bottom: 3rem;
      left: 45%;

      span {
        font-size: 1.4rem;
      }
    }

    .bottom-tip {
      width: 100%;
      height: 35px;
      line-height: 35px;
      text-align: center;
      color: #333;
      // background: #f2f2f2;
      position: absolute;
      bottom: -5px;
      font-size: 1.6rem;
      left: 0;
    }
}

::v-deep .el-input__inner::-webkit-input-placeholder {
  color: #666;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.el-select-dropdown__item {
  font-size: 14px !important;
  line-height: 34px;
  padding: 0 20px;
}
</style>
